<template>
  <div>
    <div class="module-result-content">
      <div class="result-content">
        <el-table
            :data="clientClue"
            :fit="true"
            height="calc(100vh - 175px)"
            :header-cell-style="{fontSize:'14px',}"
            :row-style="{fontSize:'14px',cursor:'pointer'}"
            :row-class-name="tableRowClassName"
            @row-click="rowChange"
            element-loading-text="数据加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.6)"
            v-loading="tableDataLoading"
            v-if="dimension"
        >
          <el-table-column type="selection"></el-table-column>
          <el-table-column label="姓名" min-width="110" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <div style="display:flex;">
                <div v-if="scope.row.name !='' "
                     style="overflow:hidden;text-overflow: ellipsis;white-space: nowrap;font-size:14px">
                  {{ scope.row.name }}
                </div>
                <div style="color:#909399" v-else>未知姓名</div>
                <div style="margin-left: 4px">
                                    <span
                                        class="phone"
                                        v-if="scope.row.mobile"
                                    ><i class="arsenal_icon arsenalshouji2" style="font-size:28px"></i></span>
                  <!-- <span
                          class="wechat"
                          v-if="scope.row.externalType&&scope.row.reachedByWeChat"
                  ><i class="arsenal_icon arsenalziyuan" style="font-size:22px"></i></span> -->
                  <span
                      class="wechat"
                      v-if="scope.row.externalType&&scope.row.externalType===1"
                  ><i class="arsenal_icon arsenalziyuan" style="font-size:22px"></i></span>
                  <span
                      class="qiyewechat"
                      v-if="scope.row.externalType&&scope.row.externalType===2"
                  ><i class="arsenal_icon arsenalqiyeweixin1" style="font-size:22px"></i></span>
                </div>

              </div>
            </template>

          </el-table-column>
          <el-table-column
              label="公司"
              min-width="145"
              :show-overflow-tooltip="true"
              align="center"
          >
            <template slot-scope="scope">
              <div style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap"
                   v-if="scope.row.companyInfo!==null">
                {{ scope.row.companyInfo.name }}
              </div>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center" min-width="65">
            <template slot-scope="scope">
              <div v-if="scope.row.status!==null" class="clueStatus">
                <el-tag :class="scope.row.status.color">{{ scope.row.status.name }}</el-tag>
              </div>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="标签" :show-overflow-tooltip="true">
               <template slot-scope="scope">
                   <div class="leads-tag-list" v-if="scope.row.tags!==null">
                       <el-tag
                               size="mini"
                               v-for="tag in scope.row.tags"
                               :key="tag.id"
                       >{{tag.name}}
                       </el-tag>
                      &lt;!&ndash; <el-tag size="mini">企业客户</el-tag>
                       <el-tag type="warning" size="mini">高端客户</el-tag>
                       <el-tag type="warning" size="mini">高净值</el-tag>
                       <el-tag type="warning" size="mini">教育</el-tag>
                       <el-tag type="warning" size="mini">CEO</el-tag>&ndash;&gt;
                   </div>
               </template>
           </el-table-column>-->
          <el-table-column
              label="联系方式"
              width="110"
              align="center"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.mobile!==null&&scope.row.mobile!==''">
                {{ scope.row.mobile }}
              </div>
              <span v-else>--</span>
            </template>

          </el-table-column>


          <el-table-column
              label="跟进人"
              min-width="70"
              :show-overflow-tooltip="true"
              align="center"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.follower!==null">
                {{ scope.row.follower.name }}
              </div>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column
              label="来源"
              min-width="80"
              align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.source |sourceType }}</span>
            </template>
          </el-table-column>
          <el-table-column
              label="更新时间"
              width="100px"
              align="center"
          >
            <template slot-scope="scope">
              <div>
                <span>{{ dateFormat(scope.row.updateTime) }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180px" align="center">
            <template slot-scope="scope">
              <div class="customerInfoOperate">
                                    <span class="customerRevise">
                                          <el-tooltip class="item" effect="dark" content="查看客户线索" placement="top">
                                               <el-button size="mini"
                                                          icon="el-icon-view"
                                                          circle
                                                          @click.native.stop="handleEdit(scope.row)"

                                               ></el-button>
                                          </el-tooltip>
                                        <el-tooltip class="item" effect="dark" content="线索分配" placement="top">
                                               <el-button size="mini"
                                                          type="primary"
                                                          icon="el-icon-sort"
                                                          circle
                                                          @click.native.stop="addLeadsAssign(scope.row.id,scope.row)"></el-button>
                                          </el-tooltip>
                                        <el-tooltip class="item" effect="dark" content="添加跟进记录" placement="top">
                                              <el-button size="mini"
                                                         type="warning"
                                                         icon="el-icon-plus"
                                                         circle
                                                         @click.native.stop="addFollowUp(scope.row,scope.row.id)"></el-button>
                                          </el-tooltip>
                                          <el-tooltip class="item" effect="dark" content="删除客户" placement="top">
                                              <el-button size="mini"
                                                         type="danger"
                                                         icon="el-icon-delete"
                                                         circle
                                                         @click.native.stop="deleteCutomer(scope.row.id)"></el-button>
                                          </el-tooltip>

                                      </span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div v-else
             class="company-card"
        >
          <div v-for="item in companyClueList"
               :key="item.companyId"
               class="company-card-item"
          >
            <el-table
                :data="item.clues"
                :fit="true"
                max-height="400px"
                :header-cell-style="{fontSize:'14px',}"
                :row-style="{fontSize:'14px',cursor:'pointer'}"
                :row-class-name="tableRowClassName"
                @row-click="rowChange"
                default-expand-all
                :tree-props="{children: 'clues'}"
                row-key="id"
                element-loading-text="数据加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.6)"
                v-loading="tableDataLoading"

            >
              <el-table-column type="selection"></el-table-column>
              <el-table-column label="姓名" min-width="110" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <div style="display:flex;">
                    <div v-if="scope.row.name !='' "
                         style="overflow:hidden;text-overflow: ellipsis;white-space: nowrap;font-size:14px">
                      {{ scope.row.name }}
                    </div>
                    <div style="color:#909399" v-else>未知姓名</div>
                    <div style="margin-left: 4px">
                                    <span
                                        class="phone"
                                        v-if="scope.row.mobile"
                                    ><i class="arsenal_icon arsenalshouji2" style="font-size:28px"></i></span>
                      <!-- <span
                              class="wechat"
                              v-if="scope.row.externalType&&scope.row.reachedByWeChat"
                      ><i class="arsenal_icon arsenalziyuan" style="font-size:22px"></i></span> -->
                      <span
                          class="wechat"
                          v-if="scope.row.externalType&&scope.row.externalType===1"
                      ><i class="arsenal_icon arsenalziyuan" style="font-size:22px"></i></span>
                      <span
                          class="qiyewechat"
                          v-if="scope.row.externalType&&scope.row.externalType===2"
                      ><i class="arsenal_icon arsenalqiyeweixin1" style="font-size:22px"></i></span>
                    </div>
                  </div>
                </template>

              </el-table-column>
              <el-table-column
                  label="公司"
                  min-width="145"
                  :show-overflow-tooltip="true"
                  align="center"
              >
                <template slot-scope="scope">
                  <div style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap"
                       v-if="scope.row.companyInfo!==null">
                    {{ scope.row.companyInfo.name }}
                  </div>
                  <span v-else>--</span>
                </template>
              </el-table-column>
              <el-table-column label="状态" align="center" min-width="65">
                <template slot-scope="scope">
                  <div v-if="scope.row.status!==null" class="clueStatus">
                    <el-tag :class="scope.row.status.color">{{ scope.row.status.name }}</el-tag>
                  </div>
                  <span v-else>--</span>
                </template>
              </el-table-column>
              <el-table-column
                  label="联系方式"
                  width="110"
                  align="center"
              >
                <template slot-scope="scope">
                  <div v-if="scope.row.mobile!==null&&scope.row.mobile!==''">
                    {{ scope.row.mobile }}
                  </div>
                  <span v-else>--</span>
                </template>

              </el-table-column>


              <el-table-column
                  label="跟进人"
                  min-width="70"
                  :show-overflow-tooltip="true"
                  align="center"
              >
                <template slot-scope="scope">
                  <div v-if="scope.row.follower!==null">
                    {{ scope.row.follower.name }}
                  </div>
                  <span v-else>--</span>
                </template>
              </el-table-column>
              <el-table-column
                  label="来源"
                  min-width="80"
                  align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.source |sourceType }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  label="更新时间"
                  width="100px"
                  align="center"
              >
                <template slot-scope="scope">
                  <div>
                    <span>{{ dateFormat(scope.row.updateTime) }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="180px" align="center">
                <template slot-scope="scope">
                  <div class="customerInfoOperate">
                                    <span class="customerRevise">
                                          <el-tooltip class="item" effect="dark" content="查看客户线索" placement="top">
                                               <el-button size="mini"
                                                          icon="el-icon-view"
                                                          circle
                                                          @click.native.stop="handleEdit(scope.row)"

                                               ></el-button>
                                          </el-tooltip>
                                        <el-tooltip class="item" effect="dark" content="线索分配" placement="top">
                                               <el-button size="mini"
                                                          type="primary"
                                                          icon="el-icon-sort"
                                                          circle
                                                          @click.native.stop="addLeadsAssign(scope.row.id,scope.row)"></el-button>
                                          </el-tooltip>
                                        <el-tooltip class="item" effect="dark" content="添加跟进记录" placement="top">
                                              <el-button size="mini"
                                                         type="warning"
                                                         icon="el-icon-plus"
                                                         circle
                                                         @click.native.stop="addFollowUp(scope.row,scope.row.id)"></el-button>
                                          </el-tooltip>
                                          <el-tooltip class="item" effect="dark" content="删除客户" placement="top">
                                              <el-button size="mini"
                                                         type="danger"
                                                         icon="el-icon-delete"
                                                         circle
                                                         @click.native.stop="deleteCutomer(scope.row.id)"></el-button>
                                          </el-tooltip>

                                      </span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="新增公司"
               :visible.sync="companyDialogFormVisible"
               custom-class="customerListDialog"
               style="text-align: left"
               :close-on-click-modal="false"
               append-to-body
    >
      <add-company ref="addCompany"></add-company>

      <div slot="footer" class="dialog-footer">
        <el-button @click="companyDialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addClientCompany">保存</el-button>
        <el-button type="primary" @click="addCompanyContinue">保存并继续新增</el-button>
      </div>
    </el-dialog>
    <!-- 线索详情抽屉 -->
    <el-drawer
        title="客户详情"
        size="70%"
        :visible.sync="customerDetailDrawer"
        :direction="customerDetailDirection">
      <leadsDetail
          :customerClueInfo="leadsForm"
          :clueId="customerClueId"
          :tags="tagsList"
          :clueInfo="clueInfo"
          ref="leadsDetail"
          @clueCompanyAdd="clueAddCompany"
          @editClue="editClue"
          :clueIndex="clueIndex"
      ></leadsDetail>
    </el-drawer>
    <!-- 新增跟进记录 -->
    <el-dialog
        title="添加跟进记录"
        :visible.sync="followupDialogVisible"
        :close-on-click-modal="false"
        width="40%">
      <AddFllowUp ref="addFollowUp"></AddFllowUp>
      <div slot="footer" class="dialog-footer">
        <el-button @click="followupDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addFollow">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 分配线索 -->
    <el-dialog
        title="线索分配"
        :visible.sync="leadsAssignDialogVisible"
        :close-on-click-modal="false"
        width="40%">
      <leads-assign ref="leadsAssign"></leads-assign>
      <span slot="footer" class="dialog-footer">
                <el-button @click="leadsAssignDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="leadsAssign">确 定</el-button>
            </span>
    </el-dialog>
    <!-- 编辑线索基本信息 -->
    <el-dialog title="编辑客户信息" :visible.sync="editLeadsDialogFormVisible" width="30%" :close-on-click-modal="false">
      <div class="leads-add-box">
        <el-form v-model="leadsForm">
          <el-form-item label="姓名" :label-width="formLabelWidth">
            <el-input v-model="leadsForm.name" placeholder="请输入客户名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="昵称" :label-width="formLabelWidth">
            <el-input v-model="leadsForm.nickName" placeholder="请输入客户昵称" clearable></el-input>
          </el-form-item>
          <el-form-item label="性别" :label-width="formLabelWidth">
            <el-radio-group v-model="leadsForm.gender" size="medium">
              <el-radio-button label="男"></el-radio-button>
              <el-radio-button label="女"></el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="生日" :label-width="formLabelWidth">
            <el-date-picker
                v-model="leadsForm.birthDay"
                type="date"
                placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="电话" :label-width="formLabelWidth">
            <el-input
                v-model="leadsForm.mobile"
                placeholder="请输入客户联系方式"
                clearable
                @blur="phoneClick(leadsForm.mobile)"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="微信号" :label-width="formLabelWidth">
               <el-input
                       v-model="leadsForm.wechat"
                       placeholder="请输入客户微信号"
                       clearable
               ></el-input>
           </el-form-item>-->
          <el-form-item label="邮箱" :label-width="formLabelWidth">
            <el-input
                v-model="leadsForm.mail"
                placeholder="请输入客户邮箱"
                clearable
                @blur="emailClick(leadsForm.mail)"
            ></el-input>
          </el-form-item>
          <el-form-item label="公司" :label-width="formLabelWidth">
            <div class="selectAndBtn">
              <el-select
                  v-model="leadsForm.companyId"
                  placeholder="请选择公司"
                  style="position: relative"
              >
                <!-- <el-option
                 v-for="item in customerClue.companyList"
                 :key="item.value"
                 :label="item.label"
                 :value="item.value">
                 </el-option>-->
                <el-input
                    placeholder="可搜索"
                    v-model="clueCompanyValue"
                    clearable
                    style="position: absolute;top: 4px;z-index: 9;"
                    size="medium"
                    @input="customerClueCompanySelect"
                >
                  <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
                <div
                    style="margin-top: 36px"
                    v-if="customerClue.companyList.length > 0"
                >
                  <el-option
                      v-for="item in customerClue.companyList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </div>
                <div
                    v-else
                    style="margin-top: 36px"
                >
                  <el-option style="display: flex;justify-content: center;align-items: center">
                    暂无数据
                  </el-option>
                </div>
              </el-select>
              <el-link type="primary" style="margin-left:20px" @click="clueAddCompany">新增公司</el-link>
            </div>

          </el-form-item>
          <el-form-item label="部门" :label-width="formLabelWidth">
            <el-input v-model="leadsForm.department" placeholder="请输入客户所在部门" clearable></el-input>
          </el-form-item>
          <el-form-item label="职位" :label-width="formLabelWidth">
            <el-input v-model="leadsForm.position" placeholder="请输入客户职位" clearable></el-input>
          </el-form-item>
          <el-form-item label="地址" :label-width="formLabelWidth">
            <el-input v-model="leadsForm.address" placeholder="请输入客户详细地址" clearable></el-input>
          </el-form-item>

          <el-form-item label="描述" :label-width="formLabelWidth">
            <el-input
                type="textarea"
                placeholder="请输入内容"
                v-model="leadsForm.description"
                maxlength="30"
                show-word-limit
            ></el-input>
          </el-form-item>

        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editLeadsDialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addClient">修 改</el-button>
      </div>
    </el-dialog>
    <!--删除客户-->

  </div>

</template>

<script>
import AddFllowUp from '../../leadsList/components/addFllowUp.vue'
import LeadsAssign from '../../leadsList/components/leadsAssign.vue'
import leadsDetail from './../../leadsList/components/leadsDetail'
import AddCompany from "../components/addCompany";

export default {
  components: {AddCompany, leadsDetail, AddFllowUp, LeadsAssign},
  AddFllowUpname: "CustomerInfoItem",
  props: {

    clientClue: {
      type: Array,
      default() {
        return []
      }
    },
    companyClueList:{
      type: Array,
      default() {
        return []
      }
    },
    isCheck: Boolean,
    index: Number,
    dimension:Boolean
  },
  data() {
    return {
      dialogVisible: false,
      dialogFormVisible1: false,
      companyDialogFormVisible: false,
      deleteCustomerDialogVisible: false,
      input: '',
      num: 0,
      pageSize: 100,
      currentPage: 1,
      accountGroup: {
        list: []
      },
      accountPerson: {
        list: []
      },
      customerCompanyName: '',
      accountGroupPerson: {
        list: []
      },
      selectCompanyList: [],
      companyPersonSelect: '',
      companyGroupSelect: '',
      companyAccountGroup: [],
      companySelectGroupList: [],
      CompanyAccountPerson: [],
      companySelectPerson: [],
      clientList: [],
      customerDetailDrawer: false,
      customerDetailDirection: 'rtl',
      innerDrawer: false,
      followupDialogVisible: false,
      followupForm: [],
      leadsAssignDialogVisible: false,
      leadsAssignRadio: '1',
      leadsAssignProps: {multiple: true},
      editLeadsDialogFormVisible: false,
      formLabelWidth: '60px',
      leadsForm: {
        nickName: '',
        gender: '',
        birthDay: '',
        address: '',
        companyId: "",
        department: "",
        description: "",
        mail: "",
        name: "",
        position: "",
        source: "ADD_MANULLY",
        mobile: ''
      },
      customerClue: {
        companyList: [],
        sourceList: [],
      },
      clueCompanyValue: '',
      customerClueId: '',
      customerClueFollowId: '',
      addCompanyInfo: {
        contactPerson: '',
        contactPersonMail: '',
        contactPersonTel: '',
        description: '',
        groupId: '',
        name: '',
        principalId: '',
        grade: 'NORMAL',
        mailSuffix: '',
      },
      tagsList: [],
      clueInfo: {},
      clueIndex: 0,
      followerList: [],
      statusList: [],
      tableDataLoading: true,
      addCompanySuccess: false
    }

  },
  filters: {
    levelType(value) {
      if (value === 'NORMAL')
        return '普通'
      if (value === 'VIP')
        return 'vip'
    },
    sourceType(value) {
      if (value === 'ADD_MANULLY')
        return '手动录入'
      else if (value === 'WECHAT_GROUP_ADD')
        return '企业微信群'
      else if (value === 'API_PUSH')
        return 'API推送'
      else if (value === 'SCAN_CODE')
        return '员工活码'
      else if (value === 'ROBOT_PUSH')
        return '通过机器人提交'
      else if (value === 'VIEW_BUSINESS_CARD')
        return '智能名片'
      else if (value === 'CUSTOM_FORM')
        return '自定义表单'
      else if (value === 'EWECHAT_ADD')
        return '企业微信好友'
      else if (value === 'EXCEL_IMPORT')
        return '批量导入'
      else if (value === 'API_PUSH_ASKBOT_WEBSITE_REGISTER')
        return '官网注册试用'
      else if (value === 'API_PUSH_ASKBOT_WEBSITE_RESERVE')
        return '官网预约演示'
      else if (value === 'API_PUSH_ASKBOT_WEBSITE_PUSH_TEL')
        return '官网推送电话'
    }
  },
  mounted() {
   /* this.getClientCompany()*/
    console.log('客户线索获取', this.clientClue)

  },
  methods: {
    editClue() {
      this.$emit('editCustomClue')
    },
    clientClueAdd(type) {
      if (this.leadsForm.name === '') {
        this.$message({
          message: '请输入客户名称',
          type: 'warning',
          duration: 2000
        })
        return;
      }
      if (!this.emailClick(this.leadsForm.mail)) {
        return;
      }
      if (!this.phoneClick(this.leadsForm.mobile)) {
        return
      }
      let url = '/scrm-api/custom-clue/' + this.customerClueId
      this.$http.put(url, this.leadsForm).then(res => {
        console.log(res)
        if (res.status === 200) {
          this.$message({
            message: '修改客户线索成功',
            duration: 2000,
            type: 'success'
          })
          this.$emit('editCustomClue')
          if (type) {
            this.editLeadsDialogFormVisible = false
          } else {
            this.editLeadsDialogFormVisible = true
          }
        }
      })
    },
    addClient() {
      this.clientClueAdd(true)
    },

    handleEdit(value) {
      this.clueIndex = value.index
      this.leadsForm = {
        nickName: '',
        gender: '',
        birthDay: '',
        address: '',
        companyId: "",
        department: "",
        description: "",
        mail: "",
        name: "",
        position: "",
        source: "ADD_MANULLY",
        mobile: ''
      }
      this.leadsForm.name = value.name
      this.leadsForm.address = value.address
      if (value.birthDay != null) {
        this.leadsForm.birthDay = value.birthDay
      }
      this.leadsForm.nickName = value.nickName
      this.leadsForm.gender = value.gender
      this.leadsForm.companyId = value.companyId
      this.leadsForm.department = value.department
      this.leadsForm.description = value.description
      this.leadsForm.mail = value.mail
      this.leadsForm.position = value.position
      this.leadsForm.source = value.source
      if (value.mobile !== null) {
        this.leadsForm.mobile = value.mobile
      }
      this.customerClueId = value.id
      if (value.tags !== null) {
        this.tagsList = value.tags
      }
      this.clueInfo = value
      this.customerDetailDrawer = true
      this.$nextTick(() => {
        if (this.$refs.leadsDetail !== undefined) {
          this.$refs.leadsDetail.getFollow(this.customerClueId)
          this.$refs.leadsDetail.getTrends(this.customerClueId)
          console.log('123', this.followerList)
          this.$refs.leadsDetail.followerList = this.followerList
          this.$refs.leadsDetail.getCustomerDetail(value.id)
          /* this.$refs.leadsDetail.customerId=value.id*/
        }
      })
    },

    //删除客户
    deleteCutomer(id) {
      this.customerClueId = id
      this.$confirm('确定删除客户线索, 是否继续?', '删除客户线索', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let url = '/scrm-api/custom-clue/' + id
        this.$http.delete(url).then(res => {
          if (res.status === 200) {
            this.$message({
              message: '删除客户成功',
              type: 'success',
              duration: 2000
            })
            this.$emit('editCustomClue')
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
          duration: 2000
        });
      });
    },
    //添加跟进记录
    addFollowUp(item, id) {
      this.followupDialogVisible = true
      this.customerClueId = id
      this.$nextTick(() => {
        console.log(this.$refs.addFollowUp)
        console.log(this.$refs.addFollowUp.followupForm.time)
        this.$refs.addFollowUp.followupForm.way = ''
        this.$refs.addFollowUp.followupForm.description = ''
        console.log(this.statusList)
        this.$refs.addFollowUp.statusList = this.statusList
        if (item.status && item.status.name !== '新建') {
          this.$refs.addFollowUp.followupForm.statusId = item.statusId
        } else {
          if (this.statusList.length > 0) {
            for (let i = 0; i < this.statusList.length; i++) {
              if (this.statusList[i].name == '跟进中') {
                this.$refs.addFollowUp.followupForm.statusId = this.statusList[i].id
              }
            }
          }
        }
      })
    },
    addFollow() {
      let followUp = {
        description: '',
        startTime: '',
        endTime: '',
        way: '',
        statusId: ''

      }
      let url = '/scrm-api/custom-clue/follow-up-record/' + this.customerClueId
      this.$nextTick(() => {
        followUp.description = this.$refs.addFollowUp.followupForm.description
        followUp.way = this.$refs.addFollowUp.followupForm.way
        followUp.startTime = this.$refs.addFollowUp.followupForm.time[0]
        followUp.endTime = this.$refs.addFollowUp.followupForm.time[1]
        followUp.statusId = this.$refs.addFollowUp.followupForm.statusId
        if (this.$refs.addFollowUp.followupForm.time === '' || this.$refs.addFollowUp.followupForm.time.length === 0) {
          this.$message({
            message: '请选择跟进时间',
            type: 'warning',
            duration: 2000
          })
          return
        }
        if (followUp.way === '') {
          this.$message({
            message: '请选择跟进方式',
            type: 'warning',
            duration: 2000
          })
          return
        }
        if (followUp.description === '') {
          this.$message({
            message: '请填写内容描述',
            type: 'warning',
            duration: 2000
          })
          return
        }
        this.$http.put(url, followUp).then(res => {
          if (res.status === 200) {
            this.$message({
              message: '添加跟进记录成功',
              duration: 2000,
              type: 'success'
            })
            this.$emit('editCustomClue')
          }
          this.followupDialogVisible = false
          if (this.$refs.leadsDetail) {
            this.$refs.leadsDetail.getFollow(this.customerClueId)
          }


        })
      })

    },
    addLeadsAssign(id, item) {
      this.leadsAssignDialogVisible = true
      this.customerClueId = id
      this.customerClueFollowId = item.followerId
      this.tagsList = []
      console.log('item', item)
      this.$nextTick(() => {
        if (item.followerId !== null) {
          this.$refs.leadsAssign.$refs.memberTree.member = item.followerId
        }
      })
    },
    //线索分配
    leadsAssign() {

      this.$nextTick(() => {
        console.log(this.$refs.leadsAssign.$refs.memberTree.member)
        let memberId = this.$refs.leadsAssign.$refs.memberTree.member
        if (this.customerClueFollowId!==memberId){
          if (memberId === '') {
            this.$message({
              message: '请选择分配跟进人',
              duration: 2000,
              type: 'warning'
            })
            return
          }
          let url = '/scrm-api/custom-clue/follower/' + this.customerClueId + '?followerId=' + memberId
          this.$http.put(url).then(res => {
            console.log(res)
            if (res.status === 200) {
              this.$message({
                message: '线索分配成功',
                duration: 2000,
                type: 'success'
              })
              this.$emit('editCustomClue')
            }

          })
        }
        this.leadsAssignDialogVisible = false
      })
    },
    //获取公司的下拉列表值
    getClientCompany() {
      this.$http.get('/api/client-company/page?num=' + this.pageSize + '&page=' + this.currentPage)
          .then(response => {
            this.selectCompanyList = response.data.data.content
            this.customerClue.companyList = response.data.data.content
          })
    },

    clueAddCompany() {
      this.$nextTick(() => {
        this.$refs.addCompany.addCompanyInfo = {
          contactPerson: '',
          contactPersonMail: '',
          contactPersonTel: '',
          description: '',
          groupId: '',
          name: '',
          principalId: '',
          grade: 'NORMAL',
          mailSuffix: '',
        }
      })
      this.companyDialogFormVisible = true
    },
    clueCompanyAdd() {
      this.$nextTick(() => {
        let addCompany = this.$refs.addCompany.addCompanyInfo
        if (addCompany.name === '') {
          this.$message('请输入公司名称')
          return
        }
        if (!this.$refs.addCompany.phoneClick(addCompany.contactPersonTel)) {
          return
        }
        if (!this.$refs.addCompany.emailClick(addCompany.contactPersonMail)) {
          return;
        }
        this.$http.post('/api/client-company', addCompany).then(res => {
          if (res.data.code === '0') {
            this.$message.success('添加公司成功')
            this.addCompanySuccess = true
            this.$nextTick(() => {
              this.$refs.leadsDetail.addCompanySuccess = true
              this.$refs.leadsDetail.getClientCompany()
              this.$emit('clueCompanyAdd')
            })
          } else {
            this.$message.error(res.message)
          }

        });
      })

    },
    //新增公司
    addClientCompany() {
      this.clueCompanyAdd()
      this.companyDialogFormVisible = false

    },
    //保存并且继续新增
    addCompanyContinue() {
      this.clueCompanyAdd()
      this.$nextTick(() => {
        this.$refs.addCompany.addCompanyInfo = {
          contactPerson: '',
          contactPersonMail: '',
          contactPersonTel: '',
          description: '',
          groupId: '',
          name: '',
          principalId: '',
          grade: 'NORMAL',
          mailSuffix: '',
        }
      })

    },

    //将获取的日期进行转换
    dateFormat(time) {
      let date = new Date(time);
      let year = date.getFullYear();
      /* 在日期格式中，月份是从0开始的，因此要加0
       * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
       * */
      let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
      let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      let hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      // 拼接
      return year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
    },
    emailClick(mail) {
      const reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      if (mail !== '') {
        if (!reg.test(mail)) {
          this.$message('请输入有效的邮箱')
          return false
        } else {
          return true
        }
      } else {
        return true
      }

    },
    phoneClick(mobile) {
      const phone = /^[1][3,4,5,7,8][0-9]{9}$/
      if (mobile !== '') {
        if (!phone.test(mobile)) {
          this.$message('请输入有效的电话号码')
          return false
        } else {
          return true
        }
      } else {
        return true
      }

    },

    //获取搜索公司的下拉值
    customerClueCompanySelect() {
      if (this.clueCompanyValue !== '') {
        let selectCompany = []
        this.selectCompanyList.forEach((item) => {
          if (!!~item.name.indexOf(this.clueCompanyValue) || !!~item.name.toUpperCase().indexOf(this.clueCompanyValue.toUpperCase())) {
            selectCompany.push(item)
          }
        })
        this.customerClue.companyList = selectCompany

      } else {
        this.customerClue.companyList = this.selectCompanyList
      }

    },
    tableRowClassName({row, rowIndex}) {
      row.index = rowIndex;
    },
    rowChange(value, column, event) {
      this.clueIndex = value.index
      console.log(value, column, event)
      this.leadsForm = {
        nickName: '',
        gender: '',
        birthDay: '',
        address: '',
        companyId: "",
        department: "",
        description: "",
        mail: "",
        name: "",
        position: "",
        source: "ADD_MANULLY",
        mobile: ''
      }
      this.leadsForm.name = value.name
      this.leadsForm.address = value.address
      if (value.birthDay != null) {
        this.leadsForm.birthDay = value.birthDay
      }
      this.leadsForm.nickName = value.nickName
      this.leadsForm.gender = value.gender
      this.leadsForm.companyId = value.companyId
      this.leadsForm.department = value.department
      this.leadsForm.description = value.description
      this.leadsForm.mail = value.mail
      this.leadsForm.position = value.position
      this.leadsForm.source = value.source
      if (value.mobile !== null) {
        this.leadsForm.mobile = value.mobile
      }
      this.customerClueId = value.id
      if (value.tags !== null) {
        this.tagsList = value.tags
      }
      this.clueInfo = value
      this.customerDetailDrawer = true
      this.$nextTick(() => {
        if (this.$refs.leadsDetail !== undefined) {
          this.$refs.leadsDetail.getFollow(this.customerClueId)
          this.$refs.leadsDetail.getTrends(this.customerClueId)
          console.log('123', this.followerList)
          this.$refs.leadsDetail.followerList = this.followerList
          this.$refs.leadsDetail.getCustomerDetail(value.id)
          /* this.$refs.leadsDetail.customerId=value.id*/
        }
      })

    },
  },
  beforeRouteLeave(to, from, next) {
    console.log(to)
    console.log(from)
    console.log(next)
  },
  watch: {
    isCheck: function (a) {
      if (a === true)
        this.checked = true
      if (a === false)
        this.checked = false

    },
    newClient: function (a) {
      this.clientList = a
      console.log(a)
    }
  }
}
</script>

<style lang="less">
@import "../../../assets/less/customlist/customerlistinfo/customerinfoitem";

.module-result-content {
  .clueStatus {

    .blue {
      background-color: #409EFF;
      color: white;
    }

    .yellow {
      background-color: #FF9500;
      color: white;
    }

    .green {
      background-color: #00C185;
      color: white;
    }

    .orange {

      background-color: #F75C5C;
      color: white;
    }

    .bluePurple {
      color: white;
      background-color: #6C5AC9;
    }

    .darkGrey {
      color: white;
      background-color: #6B798E;
    }

    .grey {
      color: white;
      background-color: #AAAAAA;
    }

    .brown {
      color: white;
      background-color: #9F704F;
    }

    .red {
      color: white;
      background-color: #FD0006;
    }

    .redPurple {
      color: white;
      background-color: #7A004F;
    }

    .black {
      color: white;
      background-color: #000000;
    }
  }
}
.company-card{
  padding: 20px 2px 0 2px;
  height: calc(100vh - 195px);
  overflow-y: scroll;
  overflow-x: hidden;
  .company-card-item{
    /*box-shadow: 0px 0px 9px 0px rgba(29, 55, 129, 0.14);*/
    border-radius: 5px;
    margin-bottom: 16px;
    padding: 20px;
    background: white;
  }
}
// .module-result-content {
//     flex: 1;
//     display: flex;
//     flex-direction: column;
//     .result-content {
//         flex: 1;
//         position: relative;
//         .el-table {
//             position: absolute;
//             overflow: hidden;

//         }
//     }
// }
// .tableBox2{
//     th{
//         padding: 0!important;
//         height: 72px;
//         line-height: 72px;
//     }
//     td{
//         padding: 0!important;
//         height: 72px;
//         line-height:72px;
//     }
// }
// .el-table__fixed{
//     width: 100% !important;
// }
.leads-tag-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  .el-tag {
    margin-right: 5px;
    margin-top: 5px;
  }

}
</style>